import { createReducer, on } from '@ngrx/store';
import { ConditionActions } from './condition.actions';
import { ICondition } from './interfaces/condition.interface';

export const conditionFeatureKey = 'condition';

export interface State {
  conditions: ICondition[];
  /** True once a load has completed, so charts can tell "none defined" from "not fetched yet". */
  loaded: boolean;
  loading: boolean;
  error: unknown;
}

export const initialState: State = {
  conditions: [],
  loaded: false,
  loading: false,
  error: null,
};

const upsert = (conditions: ICondition[], condition: ICondition): ICondition[] =>
  conditions.some((c) => c.id === condition.id)
    ? conditions.map((c) => (c.id === condition.id ? condition : c))
    : [...conditions, condition];

export const reducer = createReducer(
  initialState,

  on(ConditionActions.loadConditions, (state): State => ({ ...state, loading: true })),

  on(
    ConditionActions.loadConditionsSuccess,
    (state, { conditions }): State => ({
      ...state,
      conditions,
      loaded: true,
      loading: false,
      error: null,
    })
  ),

  on(
    ConditionActions.loadConditionsFailure,
    (state, { error }): State => ({ ...state, loading: false, error })
  ),

  on(
    ConditionActions.createConditionSuccess,
    ConditionActions.updateConditionSuccess,
    (state, { condition }): State => ({
      ...state,
      conditions: upsert(state.conditions, condition),
    })
  ),

  on(
    ConditionActions.deleteConditionSuccess,
    (state, { id }): State => ({
      ...state,
      conditions: state.conditions.filter((c) => c.id !== id),
    })
  )
);
